import { Box } from '@mui/material'
import { BetDetailsTableComponent } from '@/views/components'
import { useSportsBetDetails } from '@/views/sports-ro-calculator/hooks/use-bet-details.hook'

type Props = {
  id: string
}

export const SportsBetDetailsReport = ({ id }: Props) => {
  const { sortedRows, createSortHandler, order, orderBy, headCells } =
    useSportsBetDetails({ id })

  return (
    <Box width="100%" margin="40px auto">
      <Box overflow="hidden">
        <BetDetailsTableComponent
          sortedRows={sortedRows}
          order={order}
          orderBy={orderBy}
          createSortHandler={createSortHandler}
          headCells={headCells}
        />
      </Box>
    </Box>
  )
}
